import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface SettingsMenuSliceInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId?: string,
    editAlias?: string,
    editTitle?: string,
    editActive?: 1 | 0,
    editUrl?: string,
    editParentId?: number | null,
    editOrder?: number,
    editIsNewWindow?: 1 | 0,
    editPermission?: string,
    editHasChildren?: boolean,
    deleteModalVisible: boolean,
    deleteId: string,
    deleteTitle: string,
}

function getInitialState(): SettingsMenuSliceInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteModalVisible: false,
        deleteId: "",
        deleteTitle: "",
    }
}

export const SettingsMenuSlice = createSlice({
    name: "SettingsMenuSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<SettingsMenuSliceInterface>>) => {
            Object.assign(state, action.payload)
        }
    }
})

export const {
    reset,
    updateFields,
} = SettingsMenuSlice.actions;

export const SettingsMenuSelectors = {
    formVisible: (state: RootState) => state.settingsMenu.formVisible,
    formVariant: (state: RootState) => state.settingsMenu.formVariant,
    editId: (state: RootState) => state.settingsMenu.editId,
    editAlias: (state: RootState) => state.settingsMenu.editAlias,
    editTitle: (state: RootState) => state.settingsMenu.editTitle,
    editActive: (state: RootState) => state.settingsMenu.editActive,
    editUrl: (state: RootState) => state.settingsMenu.editUrl,
    editParentId: (state: RootState) => state.settingsMenu.editParentId,
    editOrder: (state: RootState) => state.settingsMenu.editOrder,
    editIsNewWindow: (state: RootState) => state.settingsMenu.editIsNewWindow,
    editPermission: (state: RootState) => state.settingsMenu.editPermission,
    editHasChildren: (state: RootState) => state.settingsMenu.editHasChildren,
    deleteModalVisible: (state: RootState) => state.settingsMenu.deleteModalVisible,
    deleteId: (state: RootState) => state.settingsMenu.deleteId,
    deleteTitle: (state: RootState) => state.settingsMenu.deleteTitle,
}

export const SettingsMenuReducer = SettingsMenuSlice.reducer;
